import type { RouteKey } from '@/lib/i18n/routes';

/**
 * Per-section related-route clusters used by <RelatedLinks />.
 * Each hub links to 3–5 thematically related pages to strengthen internal
 * link equity and give crawlers clear topical clusters.
 */
export const relatedLinks: Partial<Record<RouteKey, RouteKey[]>> = {
  home: ['productPms', 'productChannelManager', 'productWebsiteBuilder', 'pricing', 'compare'],
  pricing: ['features', 'productPms', 'faq', 'compare', 'contact'],
  features: ['productPms', 'productChannelManager', 'productWebsiteBuilder', 'integrations', 'pricing'],
  contact: ['about', 'faq', 'pricing', 'briefDescription'],
  about: ['testimonials', 'briefDescription', 'contact', 'blog'],
  blog: ['testimonials', 'features', 'about', 'faq'],
  faq: ['pricing', 'features', 'contact', 'briefDescription'],
  testimonials: ['about', 'features', 'productPms', 'pricing'],
  integrations: ['productChannelManager', 'features', 'productPms', 'compare'],
  productPms: ['productChannelManager', 'productWebsiteBuilder', 'integrations', 'pricing', 'features'],
  productChannelManager: ['productPms', 'integrations', 'features', 'compare'],
  productWebsiteBuilder: ['productPms', 'features', 'pricing', 'integrations'],
  forWhomSmallBusiness: ['pricing', 'productPms', 'features', 'testimonials'],
  forWhomMediumLarge: ['pricing', 'productPms', 'productChannelManager', 'integrations'],
  briefDescription: ['features', 'productPms', 'pricing', 'about'],
  compare: ['compareBestVacationRentalSoftware', 'productPms', 'pricing', 'features'],
  compareBestVacationRentalSoftware: ['compare', 'productPms', 'productChannelManager', 'pricing'],
  ai: ['features', 'productPms', 'integrations', 'pricing'],
  vacationRentalPms: ['productPms', 'productChannelManager', 'productWebsiteBuilder', 'features'],
};

export function getRelatedRoutes(routeKey: RouteKey | null | undefined): RouteKey[] {
  if (!routeKey) return [];
  return relatedLinks[routeKey] || [];
}
